
<div id="plant_dashModals" [hidden]="showText">
    <div class="modal-header">
      <h4 class="modal-title">Record Manual Readding</h4>
    </div>
    <div class="modal-body">
      <div class="modalhead_tools">
        <div class="left"><span style="color: red;" *ngIf="lastChance">This is last chance! </span>Please Add Your Recording in {{display}} minutes otherwise calibration might Lapse </div>
        <div class="right"></div>
      </div>
      <form [formGroup]="myForm" (ngSubmit)="savecallibrationdata()" >
        <div class="table-responsive">
        <table class="table table-hover modalTable">
          <thead>
            <tr>
              <th></th>
              <th>Radial(Horizontal)</th>
              <th>Tangential(Vertical)</th>
              <th>Axial</th>
            </tr>
          </thead>
          <tbody>
            <tr >
              <td>Reading {{readingnumber}} </td>
              <td>
                <input
                          id="rr1"
                          type="number"
                          formControlName="rr1"
                        />
  
              </td>
              <td>
                <input
                          id="tr1"
                          type="number"
                          formControlName="tr1"
                        />
                
              </td>
              <td>
                <input
                          id="ar1"
                          type="number"
                          formControlName="ar1"
                        />
               
              </td>
             
            </tr>
          </tbody>
        </table>
       </div>
    </form>
    </div>
    <div class="modal-footer">
      <button
      type="button"
        class="btn primary_btn"
        cdkFocusInitial
        (click)="savecallibrationdata()"
      >
        Save
      </button>
      <button mat-raised-button
        matTooltip="Stop Calibration"
        aria-label="Button that displays a tooltip when focused or hovered"
        type="button"
        class="btn default_btn"
        data-dismiss="modal"
        (click)="onNoClick()"
        cdkFocusInitial
      >
        Cancel
      </button>
    </div>
</div>
